export const light = {
  background: '#fbfbfb',
  primary: '#F55139',
  secondary: '#B85B22',
  border: '#433A5D',
  placeholder: '#6E6980',
  inputText: '#6E6980',
  iconNew: '#3B3B44',
  iconBg: 'rgba(0, 0, 0, 0.062)',
  sidebar: '#FFFFFF',
  menuicon: 'gray',
  headerSpan: '#0B5394',
  secondaryText: 'gray',
  text: '#1C2833',
  borderLight: 'rgb(231, 231, 231)',
  cardColor: '#FFFFFF',
  lightCard: '#F8F9F9',
  cardShadow: 'rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px',
  tableHeader: '#F8F9F9',
  tagsText: 'gray',
  tagsHover: '#f8f9f9',
  link: '#3699FF',
  tabhover: '#F8F9F9',
  tabShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
  siderbarActive: 'rgb(66, 66, 66)',
  cardHeading: 'hsl(234, 12%, 34%)',
  red: 'hsl(0, 78%, 62%)',
  cyan: 'hsl(180, 62%, 55%)',
  orange: '#EB984E',
  blue: 'hsl(212, 86%, 64%)',
  green: '#2ECC71',
  yellow: '#F4D03F',
  purple: '#A569BD',
  loaderBg: 'rgba(0, 0, 0, 0.6)',
  dateCard: '#fcfcfcc4',
  dateText: 'rgb(145, 145, 145)',
}

export const dark = {
  background: '#080611',
  backgroundGradient1: '#291c4a',
  border: '#433A5D',
  placeholder: '#6E6980',
  inputText: '#6E6980',
  iconNew: '#3B3B44',
  primaryPurple: '#261b46',
  secondaryPurple: '#312160',
  secondaryBackground: '#1E1D24',
  white: '#FFF',
  heading: '#289FC9',
  primary: '#00A7E5',
  secondary: '#B85B22',
  iconBg: 'rgba(255, 255, 255, 0.164)',
  sidebar: '#140F26', // '#30195E'
  menuicon: 'gray',
  headerSpan: 'white',
  secondaryText: 'gray',
  text: '#FFF',
  borderLight: '#555',
  cardColor: '#191c1f', // '#282c31'
  lightCard: '#212528',
  cardShadow: '',
  tableHeader: '#282c31',
  tagsText: 'rgb(177, 177, 177)',
  tagsHover: '#aed6f133',
  link: '#3699FF',
  tabhover: '#31353b',
  tabShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px',
  siderbarActive: 'white',
  cardHeading: '#c9d1d9',
  red: 'hsl(0, 78%, 62%)',
  cyan: 'hsl(180, 62%, 55%)',
  orange: '#EB984E',
  blue: 'hsl(212, 86%, 64%)',
  green: '#2ECC71',
  yellow: '#F4D03F',
  purple: '#A569BD',
  loaderBg: 'rgba(0, 0, 0, 0.322)',
  dateCard: '#282c31b9',
  dateText: 'rgb(145, 145, 145)',
  borderColor: 'rgba(110, 105, 128, 0.40)',
  grayColor: '#3B3B44',
  secColor: '#30215D',
  grayText: 'rgba(255, 255, 255, 0.40)',
  lightGrayText: 'rgba(255, 255, 255, 0.60)',
  greenText: '#3FBE94',
}
